"use client";

import React from "react";
import { ChevronDown } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";

/**
 * BrokerProgram — Section 6: FAQ
 * Drop-in für: src/pages/BrokerProgram/sections/FrequentlyAskedQuestions.tsx
 */

const faqs = [{
  q: "Kostet die Anmeldung etwas?",
  a: "Nein. Die Anmeldung als Vermittler ist komplett kostenlos und ohne Verpflichtung. Es gibt keine Setup-Gebühr und keine monatlichen Kosten."
}, {
  q: "Wann erhalte ich meine Provision?",
  a: "Die Provision wird monatlich ausgezahlt — automatisch auf Ihr hinterlegtes Konto. Auszahlung erfolgt jeweils am 15. des Folgemonats für die Vormonats-Bestellungen."
}, {
  q: "Wie lange läuft die Provision?",
  a: "30 % der Abo-Gebühr für die ersten 12 Monate jedes vermittelten Kunden. Danach läuft das Abo regulär weiter — Sie haben Ihren Anteil verdient."
}, {
  q: "Gibt es einen Mindestumsatz?",
  a: "Nein. Sie können eine einzige Empfehlung pro Jahr machen oder hundert. Es gibt keine Mindestmenge und keine Strafen, wenn nichts passiert."
}, {
  q: "Wie wird der Vermittler-Link getrackt?",
  a: "Über Cookie-basiertes Attribution-Tracking. Klickt jemand Ihren Link und schliesst innerhalb von 30 Tagen ein Abo ab, wird die Empfehlung Ihnen zugeordnet — auch wenn der Kauf später passiert."
}, {
  q: "Was, wenn der Kunde sein Abo kündigt?",
  a: "Sie erhalten Provision für die tatsächlich bezahlten Monate, max. 12. Kündigt der Kunde nach 4 Monaten, haben Sie für 4 Monate Provision verdient. Fair und transparent."
}, {
  q: "Kann ich das Programm jederzeit verlassen?",
  a: "Ja. Eine kurze E-Mail genügt. Sie behalten alle bereits verdienten Provisionen, auch nach Austritt."
}];
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section className="bg-secondary py-20 md:py-24">
      <div ref={ref} className={`max-w-3xl mx-auto px-4 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center mb-12 md:mb-14">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-foreground mb-4 leading-tight">
            Häufige Fragen
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground">
            Was Vermittler vor der Anmeldung wissen wollen.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((item, i) => <details key={i} className="group bg-background border border-border rounded-xl overflow-hidden">
              <summary className="flex items-center justify-between cursor-pointer px-6 py-5 font-medium text-foreground hover:bg-secondary/50 transition-colors">
                <span className="pr-4">{item.q}</span>
                <ChevronDown className="w-5 h-5 text-muted-foreground group-open:rotate-180 transition-transform shrink-0" />
              </summary>
              <div className="px-6 pb-5 text-muted-foreground leading-relaxed">
                {item.a}
              </div>
            </details>)}
        </div>
      </div>
    </section>;
}